
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import BusinessSection from 'components/business/BusinessSection';
import ContentSection from 'components/business/ContentSection';
import PartnershipSection from 'components/business/PartnershipSection';
import ProductSection from 'components/business/ProductSection';
function business() {
    return (<>
      <BusinessSection />
      <ContentSection />
      <PartnershipSection />
      <ProductSection />
    </>);
}
export default business;

    async function __Next_Translate__getStaticProps__1a181a8c0e7__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/business',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a181a8c0e7__ as getStaticProps }
  